import { Creds } from './creds';

const API_KEY = 'AIzaSyCJfMw1sSxULRmhj8swz248ZrQfvijjLsM';
const OAUTH_CLIENT_ID = '617199861077-prdf3a2qa1bh8b8ccnipcm8ck3h0fa6a.apps.googleusercontent.com';
const SCOPES = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
].join(' ');
const SIGN_IN_DIV_ID = 'bish-signin';

let gapi;

// TODO: Chuck this for Firebase Auth?

/**
 * Class that authenticates to Google. Should be deprecated now. Google is phasing it out for GIS.
 * https://developers.googleblog.com/en/discontinuing-authorization-support-for-the-google-sign-in-javascript-platform-library/
 */
export class GoogleAuthenticator {
  private isBooted: boolean = false;
  private isSignedIn: boolean = false;
  private isAuthorized: boolean = false;
  private creds: Creds;
  private authInstance: any;

  constructor(divForButton: HTMLDivElement) {
    divForButton.id = SIGN_IN_DIV_ID;

    this.authInstance = undefined;
  }

  getCreds(): Creds {
    return this.creds;
  }

  /**
   * Updates the access token after re-authentication.
   * @param {Creds} creds The new credentials.
   */
  private updateToken(creds: Creds) {
    this.isAuthorized = true;
    this.creds = creds;
    // oauth token in access_token
    // id token in id_token
    gapi.client.setApiKey(creds.access_token);
  }

  /**
   * Loads the gapi script, then loads the client, auth2, signin2 libraries and initializes.
   */
  async boot() {
    if (typeof window['gapi'] === 'undefined') {
      // Load the Google API script.
      await new Promise((resolve, reject) => {
        // If we cannot load the Google API script, then die.
        const gScript = document.createElement('script');
        gScript.setAttribute('async', 'async');
        gScript.setAttribute('defer', 'defer');
        gScript.onerror = err => reject(err);
        gScript.addEventListener('load', () => resolve(true));
        gScript.setAttribute('src', 'https://apis.google.com/js/api.js');
        document.body.appendChild(gScript);
      });

      gapi = window['gapi'];

      // Load initial API client and auth2 modules.
      await new Promise((resolve, reject) => {
        if (typeof gapi === 'undefined') {
          reject('gapi was not defined');
        }
        gapi.load('client:auth2:signin2', {
          callback: () => {
            gapi.client.init({
              'apiKey': API_KEY,
              'clientId': OAUTH_CLIENT_ID,
              'scope': SCOPES,
            }).then(() => {
              this.isBooted = true;

              // See if we are already signed in and authorized.
              const authInstance = gapi.auth2.getAuthInstance();
              const currentUser = authInstance.currentUser.get();
              authInstance.isSignedIn.listen(signedIn => {
                this.isSignedIn = signedIn;
              });
              this.authInstance = authInstance;
              this.isSignedIn = authInstance.isSignedIn.get();

              const hasScopes = currentUser.hasGrantedScopes(SCOPES);
              if (hasScopes) {
                const result = gapi.client.getToken();
                // TODO: It is possible to revoke the app's access, but this still returns
                //     an access token.
                if (result && !result.error) {
                  this.updateToken(result);
                }
              }
              resolve(true);
            }, err => {
              reject(err);
            });
          },
          onerror: err => reject(err),
        });
      });
    }
  }

  /**
   * Authenticates the user or waits for them to sign in (by rendering a signin button).
   */
  async authenticateOrWaitForSignIn(): Promise<Creds> {
    if (!this.isBooted) {
      await this.boot();
    }

    // If signed in, but never were granted scopes or an OAuth token, sign out.
    if (this.isSignedIn && !this.isAuthorized) {
      await this.authInstance.signOut();
      // TODO: Should we call authInstance.disconnect() ?
      this.isSignedIn = false;
    }

    let googleUser;

    // If not signed in, then do it. If this errors, then render a signin button.
    if (!this.isSignedIn) {
      try {
        googleUser = await this.authInstance.signIn();
      } catch (err) {
        googleUser = await new Promise((resolve, reject) => {
          gapi.signin2.render(SIGN_IN_DIV_ID, {
            'scope': 'profile email',
            'width': 240,
            'height': 50,
            'longtitle': true,
            'theme': 'dark',
            'onsuccess': user => resolve(user),
            'onfailure': err => reject(err),
          });
        });
      }
      console.log(`Google User is ${googleUser.getId()}`);
    }

    this.isSignedIn = true;

    const result = gapi.client.getToken();
    if (result && !result.error) {
      this.updateToken(result);
    }

    console.log(`authenticateOrWaitForSignIn() produced an id token of ${this.creds.id_token}`);
    return this.creds;
  }

  /**
   * Reloads the authentication response from Google.
   */
  refresh(): Promise<Creds> {
    const user = this.authInstance.currentUser.get();
    return user.reloadAuthResponse().then(authResponse => {
      this.creds = authResponse;
      return this.creds;
    }).catch(err => {
      console.error(`Found an error when reloadAuthResponse():`);
      console.dir(err);
    });
  }
}
